import {useCallback, useEffect, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import {euroFormat} from "../../../utils/usefullFunctions";
import CustomDataGrid from "../../table/CustomDataGrid";

const columns = [
    {name: 'name', header: 'Naam', minWidth: 300,editable: false},
    {
        name: 'cost', header: 'Kost', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => {
            if (value) return euroFormat(value)
        },
        onRender: (cellProps, {data}) => {
            if (data.id === 0) cellProps.style.background = '#f8f8f8'
        }
    },
    {
        name: 'sale', header: 'Verkoop', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => {
            if (value) return euroFormat(value)
        },
        onRender: (cellProps, {data}) => {
            if (data.id === 0) cellProps.style.background = '#f8f8f8'
        }
    }
];

const HardwareTable = () => {
    const {values, setFieldValue} = useFormikContext();
    const {service_form_project_products_cost, service_form_project_data_hardware} = values

    const [dataSource, setDataSource] = useState(service_form_project_data_hardware);


    useEffect(() => {
        setFieldValue("service_form_project_hardware_cost", {
            cost: dataSource[1].cost,
            sale: dataSource[1].sale,
        })
        setFieldValue("service_form_project_data_hardware", dataSource)

    }, [dataSource])

    useEffect(() => {
        const data = [...dataSource]
        data[0].cost = service_form_project_products_cost.cost
        data[0].sale = service_form_project_products_cost.list
        setDataSource(data)
    }, [service_form_project_products_cost])


    const onEditComplete = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];

        if (rowId === 1) {
            // Only the 2nd row can be changed and when that happens parse the value first
            value = parseInt(value || 0)
            data[rowId][columnId] = value;
        } else return null

        setDataSource(data);
    }, [dataSource])

    return <CustomDataGrid
            idProperty="id"
            onEditComplete={onEditComplete}
            editable={true}
            columns={columns}
            dataSource={dataSource}

        />
}


export default HardwareTable